export const GENERIC_PROJECT_HORIZONTAL_NAV = 'GENERIC_PROJECT_HORIZONTAL_NAV' as const;

/**
 * @deprecated delete this constant when platform.atlassian.griffin-navigation-redesign is cleaned up.
 * Replace value with undefined where used in routes.
 */
export const GENERIC_BUSINESS_TRANSITIONAL_PROJECT_HORIZONTAL_NAV =
	'GENERIC_BUSINESS_TRANSITIONAL_PROJECT_HORIZONTAL_NAV' as const;
